module.exports = __webpack_public_path__ + "media/images/slide1-1bcb17db9a94baf0ad406820e1780a55a1b28203f427d9d25088a33fb9d49dea.jpg";